<template>
  <!-- 退款预警 -->
  <div class="warning">
    <!-- 表格体 -->
    <div class="content">
      <!-- 头部按钮 -->
      <header class="head">
        <button class="create" v-zoom="{ from: pageName, name: '创建任务' }" @click="CreateTask">
          <img
            src="@/assets/images/member/new_establish.png"
            style="
             display: inline-block;
             float: left;
             width: 14px;
             height: 14px;
             color: #ffffff;
             margin: 8px 0px 0px 6px"
          />创建任务
        </button>
        <div class="right">
          <div>
            开启状态:
            <el-select v-model="searchForm.isOpen" placeholder="请选择" style="width: 116px; margin-left:6px">
              <el-option label="全部" value=""></el-option>
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
            <el-input v-model="searchForm.keyWord" placeholder="请输入任务名称" style="width: 240px; margin: 0 16px 0 8px;"> </el-input>
          </div>
          <button class="search" @click="getTaskList"><i class="el-icon-search" style=" margin-left: -8px;"></i>查询</button>
          <button class="reset" @click="resetForm">重置</button>
        </div>
      </header>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        v-loading="talbeLoading"
        style="width: 100%; marginTop: 20px;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="taskName" label="任务名称" width="200"></el-table-column>
        <el-table-column prop="content" label="短信内容" width="500">
          <template slot="header" slot-scope="scope">
            <span>短信内容</span> &nbsp;
            <span class="open" v-show="!tableOpenAll" @click="tableOpenAll = true">（展开全部）</span>
            <span class="stop" v-show="tableOpenAll" @click="tableOpenAll = false">（收起全部）</span>
          </template>
          <template slot-scope="scope">
            <el-tooltip class="tooltip" effect="light" :content="scope.row.content" placement="top">
              <div class="hoveTitle" v-show="!tableOpenAll">
                {{ scope.row.content }}
              </div>
            </el-tooltip>
            <div class="hoveTitleShowMore" v-show="tableOpenAll">
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="任务时间">
          <template slot-scope="scope">
            {{ scope.row.taskType == 1 ? "持续开启" : "指定时间" }}
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
        <el-table-column prop="operateTime" label="最后修改时间" width="200"></el-table-column>

        <el-table-column>
          <template slot="header" slot-scope="scope">
            <div>
              优先级
              <el-tooltip
                class="item"
                effect="light"
                content="数字越小优先级越高会优先发送，同一订单同时满足多个任务只发优先级高的，其他不发，避免重复，优先级相同则以最后修改时间先发。"
                placement="top-start"
              >
                <i class="el-icon-question tips" :style="{ color: '#CCCCCC' }"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.sort"
              @change="handleChange($event, scope.row)"
              :min="1"
              :max="5"
              size="small"
              style="width: 100px;"
            ></el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="开启状态">
          <template slot-scope="scope">
            <el-switch
              active-color="#49C568"
              v-model="scope.row.isOpen"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch($event, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="handle">
              <span v-zoom="{ from: pageName, name: '编辑' }" @click="handleEdit(scope.row)" class="operation">编辑</span>
              <span @click="handleDelete(scope.row)" v-zoom="{ from: pageName, name: '删除' }" class="operation">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="searchForm.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="searchForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 创建任务抽屉 -->
    <shop-create-task
      v-if="createShopFlag"
      :drawer="createTaskFlag"
      :editData="editData"
      :createTime="createTime"
      @close="createTaskIsShow"
    ></shop-create-task>
  </div>
</template>

<script>
import shopCreateTask from "./shopCreateTask";
import { queryTaskList, openState, deleteId, getDetails } from "@/api/serviceCenter/refundWaring";

export default {
  components: {
    shopCreateTask,
  },
  props: ["pageName"],
  data() {
    return {
      createShopFlag: false,
      searchForm: {
        // 查询条件
        isOpen: "",
        keyWord: null,
        size: 10,
        current: 1,
      },
      total: 0,
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      tableOpenAll: false, // 短信内容展开
      createTaskFlag: false, // 创建任务抽屉状态控制
      createTime: "",
      // 存储编辑时获取的详情信息
      editData: null,
    };
  },
  created() {
    this.getTaskList();
  },
  methods: {
    CreateTask() {
      this.createShopFlag = true;
      this.createTaskFlag = true;
      var date = new Date();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var getHours = date.getHours();
      var getMinutes = date.getMinutes();
      var getSeconds = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (getHours >= 0 && getHours <= 9) {
        getHours = "0" + getHours;
      }
      if (getMinutes >= 0 && getMinutes <= 9) {
        getMinutes = "0" + getMinutes;
      }
      if (getSeconds >= 0 && getSeconds <= 9) {
        getSeconds = "0" + getSeconds;
      }
      var currentDate = date.getFullYear() + "-" + month + "-" + strDate + " " + getHours + ":" + getMinutes + ":" + getSeconds;
      this.createTime = currentDate;
    },
    /**
     * 获取退款预警列表
     */
    getTaskList() {
      this.talbeLoading = true;
      queryTaskList(this.searchForm).then((res) => {
        this.talbeLoading = false;
        this.tableData = res && res.data.records;
        this.total = res && +res.data.total;
        this.searchForm.current = res && res.data.current;
      });
    },
    /**
     * 模板开启状态
     */
    changeSwitch(val, { id }) {
      const param = {
        id: +id,
        isOpen: val,
      };
      openState(param).then((res) => {
        if(res.code){
          this.$message.success(res.message);
          this.getTaskList();
        }else{
          if(res.data){
            this.$message.error(res.data.message)
          }else{
            this.$message.error(res.message)
          }
        }
      });
    },
    /**
     * 模板优先级变化
     */
    handleChange(val, id) {
      const param = {
        id: id.id,
        sort: val,
      };
      openState(param).then((res) => {
        if(res.code == 1){
          this.$message.success(res.message);
        }else{
          if(res.data){
            this.$message.error(res.data.message)
          }else{
            this.$message.error(res.message)
          }
        }
      });
    },
    /**
     * 模板编辑
     */
    handleEdit({ id }) {
      getDetails(id).then((res) => {
        this.editData = res && res.data;
        this.createTaskFlag = true;
        this.createShopFlag = true;
      });
    },
    /**
     * 模板删除
     */
    handleDelete({ id, isOpen }) {
      if (isOpen == 1) {
        this.$message.warning("请先关闭任务");
        return;
      }
      this.$confirm("您确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          deleteId(+id).then((res) => {
            if(res.code == 1){
              this.$message.success("删除成功");
              this.searchForm.current = 1;
              this.getTaskList();
            }else{
              if(res.data){
                this.$message.error(res.data.message)
              }else{
                this.$message.error(res.message)
              }
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 重置表单
    resetForm() {
      this.searchForm = {
        isOpen: "",
        taskName: null,
        size: 10,
        current: 1,
      };
      this.getTaskList();
    },
    /**
     * 分页变化
     */
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.searchForm.current = 1;
      this.getTaskList();
    },
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getTaskList();
    },
    /**
     * 创建任务隐藏
     */
    createTaskIsShow(state) {
      this.createTaskFlag = false;
      this.createShopFlag = false;
      this.editData = null;
      if (state) this.getTaskList();
    },
  },
};
</script>

<style lang="scss" scoped>
.warning {
  box-sizing: border-box;
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      button {
        width: 98px;
        height: 32px;
        line-height: 30px;
        outline: none;
        border: none;
        border-radius: 3px;
        background-color: white;
        cursor: pointer;
        transition: all 0.2s;
      }
      .create {
        color: #fff;
        background-color: #fe4d45;
        &:hover {
          opacity: 0.9;
        }
      }
      .right {
        display: flex;
        align-items: center;
        color: #333;
        .search {
          margin-right: 8px;
          margin-left: -8px;
          border: 1px solid rgba(254, 77, 69, 1);
          color: #fe4d45;
          &:hover {
            background-color: #fe4d45;
            color: #fff;
          }
        }
        .reset {
          border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
          color: rgba(0, 0, 0, 0.65);
          &:hover {
            border: 1px solid #fe4d45;
            color: #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
    }
    .open,
    .stop {
      color: rgb(127, 133, 233);
      font-weight: 400;
      cursor: pointer;
    }
    .tooltip {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .handle {
      display: flex;
      justify-content: space-around;
      .operation {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      span {
        cursor: pointer;
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
